export interface IPermissionData {
    permissionId?: number;
    permissionName?: string;
}

export class Permission {
    permissionId: number;
    permissionName: string;

    constructor(data: Partial<IPermissionData>) {
        this.permissionId = data?.permissionId;
        this.permissionName = data?.permissionName;
    }

}